"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schoolSelect = exports.schoolItems = exports.patientAppealSelect = exports.patientAppealItems = exports.discoveryMethodSelect = exports.discoveryMethodItems = exports.discoveryMethodConfig = exports.DiscoveryMethodDefinition = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _types = require("../../types");

var _config = require("../config");

var _selectConfig = require("../../fields/Select/selectConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _selectConfig.SelectDefinition;
});

var ListComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ListComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var OptionDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionDefinition;
});

var discoveryMethodSelect = {
  key: 'reason',
  label: 'How did you hear about us?',
  type: 'select',
  items: [],
  validation: [{
    required: true
  }]
};
exports.discoveryMethodSelect = discoveryMethodSelect;
var discoveryMethodItems = [{
  key: 'Patient Appeal'
}, {
  key: 'R & Be talk from ASSET'
}];
exports.discoveryMethodItems = discoveryMethodItems;
var patientAppealSelect = {
  key: 'patientAppeal',
  label: 'Patient Appeal',
  type: 'select',
  items: [],
  validation: [{
    required: true
  }]
};
exports.patientAppealSelect = patientAppealSelect;
var patientAppealItems = [];
exports.patientAppealItems = patientAppealItems;
var schoolSelect = {
  key: 'school',
  label: 'School',
  type: 'select',
  items: [],
  validation: [{
    required: true
  }]
};
exports.schoolSelect = schoolSelect;
var schoolItems = [];
exports.schoolItems = schoolItems;
var discoveryMethodConfig = {
  type: 'discoveryMethod',
  defaultItems: discoveryMethodItems,
  fields: [discoveryMethodSelect],
  validation: [].concat((0, _toConsumableArray2["default"])((patientAppealSelect.validation || []).map(function (patientAppealValidationRule) {
    return {
      validateIfFieldMatchesValue: {
        field: discoveryMethodSelect.key,
        value: 'patientAppeal',
        validation: {
          fieldValidation: {
            field: patientAppealSelect.key,
            validation: patientAppealValidationRule
          }
        }
      }
    };
  })), (0, _toConsumableArray2["default"])((schoolSelect.validation || []).map(function (schoolValidationRule) {
    return {
      validateIfFieldMatchesValue: {
        field: discoveryMethodSelect.key,
        value: 'school',
        validation: {
          fieldValidation: {
            field: schoolSelect.key,
            validation: schoolValidationRule
          }
        }
      }
    };
  })))
};
exports.discoveryMethodConfig = discoveryMethodConfig;

var DiscoveryMethodDefinition = _flowRuntime["default"].type("DiscoveryMethodDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("items", _flowRuntime["default"].array(_flowRuntime["default"].ref(OptionDefinition))), _flowRuntime["default"].property("appealItems", _flowRuntime["default"].array(_flowRuntime["default"].ref(OptionDefinition))), _flowRuntime["default"].property("schoolItems", _flowRuntime["default"].array(_flowRuntime["default"].ref(OptionDefinition))), _flowRuntime["default"].property("type", _flowRuntime["default"].string("discoveryMethod")))));

exports.DiscoveryMethodDefinition = DiscoveryMethodDefinition;